export default {
    DATA_DEVICE_CODENTIFY: 'data-codentify',
    DATA_DEVICE_FACTORY: 'data-factory',
    DATA_LANGUAGE: 'data-language',
    DATA_REFRESH_TOKEN_URL: 'data-refresh-token-url',
    LANG: 'lang',
    GEO_RESTRICTION: 'gr',
    USERNAME: 'username',
    FWU_TARGET: 'target',
    FWU_VERSION: 'version',
    IS_SBL: 'isSblFirmware',
};
